import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Page } from "@/components/site/Layout";

export function Contact() {
  const [f, setF] = useState({ name: "", email: "", topic: "question", message: "", order_reference: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { const r = await api.post("/contact", f); setMsg(r.data.message); } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Page eyebrow="Contact" title="We're here to help" intro="Questions about an order, a revision or deleting your data — send us a note." testid="contact-page">
      {msg ? <p className="card-parch max-w-xl p-8" role="status" data-testid="contact-success">{msg}</p> : (
        <form onSubmit={submit} className="grid max-w-xl gap-5" data-testid="contact-form">
          <label><span className="label">Your name</span><input required className="field" value={f.name} onChange={set("name")} data-testid="contact-name" /></label>
          <label><span className="label">Email</span><input required type="email" className="field" value={f.email} onChange={set("email")} data-testid="contact-email" /></label>
          <label><span className="label">Topic</span>
            <select className="field" value={f.topic} onChange={set("topic")} data-testid="contact-topic">
              <option value="question">General question</option><option value="order">About my order</option>
              <option value="deletion_request">Delete my data</option><option value="other">Something else</option>
            </select></label>
          <label><span className="label">Order reference (optional)</span><input className="field" value={f.order_reference} onChange={set("order_reference")} placeholder="SM-XXXXXXXX" data-testid="contact-reference" /></label>
          <label><span className="label">Message</span><textarea required minLength={5} rows={5} className="field" value={f.message} onChange={set("message")} data-testid="contact-message" /></label>
          {err && <p className="text-sm text-[var(--rose)]" role="alert">{err}</p>}
          <button className="btn-plum w-fit" disabled={busy} data-testid="contact-submit">{busy ? "Sending…" : "Send message"}</button>
        </form>
      )}
    </Page>
  );
}

export function Track() {
  const [f, setF] = useState({ email: "", reference: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    try { const r = await api.post("/track/lookup", f); setMsg(r.data.message); } catch (e2) { setErr(errMsg(e2)); }
  };
  return (
    <Page eyebrow="Order tracking" title="Find your order" intro="Your private order link was shown after checkout. Lost it? Enter your email and order reference and we'll send it again." testid="track-page">
      <form onSubmit={submit} className="grid max-w-md gap-5">
        <label><span className="label">Email used at checkout</span><input required type="email" className="field" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="order-tracking-email-input" /></label>
        <label><span className="label">Order reference</span><input required className="field uppercase" placeholder="SM-XXXXXXXX" value={f.reference} onChange={(e) => setF({ ...f, reference: e.target.value })} data-testid="order-tracking-search-input" /></label>
        {err && <p className="text-sm text-[var(--rose)]" role="alert">{err}</p>}
        {msg && <p className="card-parch p-5 text-sm" role="status" data-testid="order-tracking-message">{msg}</p>}
        <button className="btn-plum w-fit" data-testid="order-tracking-submit">Send my link</button>
      </form>
    </Page>
  );
}
